import { useSetPosOrderSessionData } from "@/shared/atoms/usePosOrderTableSessionAtoms";
import usePosOrderTable from "@/shared/atoms/usePosOrderTable";
import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { OrdersSession } from "@/shared/v2/queries/interfacesV2";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

const useOrdersSessionByTableQuery = () => {
  const branch = useBranchId();
  const [table] = usePosOrderTable();
  const setSessionData = useSetPosOrderSessionData();
  const queryKey = ["ordersSession", "order", table?.item_id, branch];
  const query = useQuery<OrdersSession>({
    queryKey: queryKey,
    enabled: table !== null && table?.item_id !== -1 && table?.item_id > 0,
    queryFn: () =>
      get2(
        `/internal/secure/pos/v1/order/sessions/${branch}/${table?.item_id}`
      ),
    refetchOnMount: false,
  });

  useEffect(() => {
    if (query?.data) {
      setSessionData({
        session_id: query.data.item_id,
        total_amount: query.data.total_amount,
        order_ids: query.data.order_ids,
        current_table_ids: query.data.current_table_ids,
      });
    }
  }, [query.data, setSessionData]);

  return query;
};

export default useOrdersSessionByTableQuery;
